import React from 'react';
import { Box, Typography } from '@mui/material';

const navy = '#1A3A6B';

const QUICK_LINKS = [
  { label: 'Registration Fees', href: 'https://cmdfw.org/balavihar/balavihar-registration/' },
  { label: 'Sessions, Location & Timings', href: 'https://cmdfw.org/balavihar/sessions-locations-timings/' },
  { label: 'Bala Vihar FAQ', href: 'https://cmdfw.org/balavihar/balavihar-faq/' },
  { label: 'Family Handbook', href: 'https://cmdfw.org/balavihar/balavihar-faq/#:~:text=Family%20Handbook%20(PDF)' },
];

const rowSx = {
  display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: 1,
};

export default function FooterBar() {
  return (
    <Box component="footer" sx={{
      bgcolor: '#ffffff', color: '#555',
      pt: '8px', pb: '6px', px: 2,
      borderTop: '1px solid #e0d8c8',
    }}>
      {/* Quick-links row */}
      <Box sx={{ ...rowSx, mb: '5px' }}>
        {QUICK_LINKS.map((link, i) => (
          <React.Fragment key={link.label}>
            {i > 0 && <Typography variant="caption" sx={{ opacity: 0.4 }}>|</Typography>}
            <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: navy, textDecoration: 'none', fontWeight: 600 }}
              >
                {link.label}
              </a>
            </Typography>
          </React.Fragment>
        ))}
      </Box>

      {/* Copyright + locations row */}
      <Box sx={rowSx}>
        <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
          © {new Date().getFullYear()} Chinmaya Mission Dallas Fort-Worth · A 501(c)(3) nonprofit
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.4 }}>|</Typography>
        <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
          <span style={{ color: '#f37f0b' }}>Saaket:</span> 17701 Davenport Rd, Dallas TX
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.4 }}>|</Typography>
        <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
          <span style={{ color: '#f37f0b' }}>Chitrakoot:</span> 900 N Beltline Rd, Irving TX
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.4 }}>|</Typography>
        <Typography variant="caption" sx={{ whiteSpace: 'nowrap' }}>
          <span style={{ color: '#f37f0b' }}>Frisco:</span> 12615 Jereme Trail, Frisco TX
        </Typography>
      </Box>
    </Box>
  );
}
